import React, { useCallback, useState } from 'react';
import { ConfigurationRow, LongNameWrapper } from './SchemaConfigValuesUI';
import { useFunnelPartitionModel } from '../utils';
import { DataModelerSelectSchemaFieldKey } from '../DataModelerFieldDropdown';
import EditableTextArea from '../../../../components/EditableTextArea';
import LongNameWithTooltip from '../LongNameWithTooltip';
import {
  ConfigurationLabel,
  ConfigurationValue,
  NameWithIconWrapper,
} from '../DataModelerCommonUI';
import InformationalTooltip from '../../../../components/InformationalTooltip';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import styled from 'styled-components';
import { SquareRemoveButton, TextButton } from '../../../../components/Button';
import { useDataModelerContext } from '../../DataModelerContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

const FunnelPartitionsList = () => {
  const [visible, setVisible] = useState(false);
  const { draftEdits, schemaObj, isEditMode } = useDataModelerContext();
  const {
    existingPartitions,
    draftPartitions,
    addDraftPartitionField,
    removeDraftPartitionField,
    updateDraftPartitionName,
    unavailableFieldKeys,
    partitionNameValidator,
  } = useFunnelPartitionModel({ draftEdits, schemaObj });

  const showHeader =
    isEditMode || existingPartitions.length + draftPartitions.length > 0;

  const handleAddPartitionField = useCallback(
    (fieldKey: string) => {
      setVisible(false);
      addDraftPartitionField(fieldKey);
    },
    [addDraftPartitionField],
  );

  return (
    <>
      {showHeader && (
        <ConfigurationLabel>
          Additional Funnel and Path Partition Fields can be configured once the
          connection is established and the tables are selected.
        </ConfigurationLabel>
      )}
      <Wrapper>
        {existingPartitions.map(({ fieldKey, fieldName, name }) => (
          <ConfigurationRow key={fieldKey}>
            <LongNameWrapper>
              <LongNameWithTooltip name={name} />
            </LongNameWrapper>
            <div>{fieldName}</div>
          </ConfigurationRow>
        ))}
        {isEditMode && (
          <>
            {draftPartitions.map(({ fieldKey, fieldName, name }) => {
              const setName = (newName: string) => {
                updateDraftPartitionName(fieldKey, newName);
              };
              return (
                <ConfigurationRow key={fieldKey}>
                  <div>
                    <EditableTextArea
                      defaultRows={1}
                      disabled={false}
                      placeholder={fieldKey}
                      value={name}
                      validation={partitionNameValidator(fieldKey)}
                      onChange={setName}
                    />
                  </div>
                  <ConfigurationValue>
                    <div>{fieldName}</div>
                    <SquareRemoveButton
                      onClick={() => removeDraftPartitionField(fieldKey)}
                      content={'Remove'}
                    />
                  </ConfigurationValue>
                </ConfigurationRow>
              );
            })}
            {!visible ? (
              <NameWithIconWrapper>
                <TextButton onClick={() => setVisible(true)}>
                  + Add Partition Field
                </TextButton>
                <InformationalTooltip
                  tooltipOption={
                    dataModelLabelInfoTooltipOptions.addFunnelPartition
                  }
                />
              </NameWithIconWrapper>
            ) : (
              <ConfigurationRow>
                <div>Select Field</div>
                <div>
                  <DataModelerSelectSchemaFieldKey
                    key={`add-partition-${draftPartitions.length}`}
                    fieldKey={undefined}
                    setFieldKey={handleAddPartitionField}
                    fieldKeysFilter={unavailableFieldKeys}
                  />
                </div>
              </ConfigurationRow>
            )}
          </>
        )}
      </Wrapper>
    </>
  );
};

export default FunnelPartitionsList;
